import type { LayoutSections } from '@teemill/modules/app';

export const blankConfig: LayoutSections = {
  announcement: false,
  header: false,
  sidebar: false,
  content: {
    show: true,
    head: true,
    width: '100%',
  },
  footer: false,
  subFooter: false,
  navBar: false,
};
